/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Receipt_DiscountInputs */

const vi_receipt_discount = /** @type {(inputs: Receipt_DiscountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiết khấu`)
};

/**

* @param {Receipt_DiscountInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const receipt_discount = /** @type {((inputs?: Receipt_DiscountInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Receipt_DiscountInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_receipt_discount(inputs)
});